module.exports = __webpack_public_path__ + "static/media/insert-agent.b2bbf577.png";